export default __webpack_public_path__ + "locales/ja-JP/EmptyView.json?hash=5aded1468293cb7bd8641311d84f993c";